/* unplugin-vue-components disabled */import script from "./authInfos.vue?vue&type=script&setup=true&lang=js"
export * from "./authInfos.vue?vue&type=script&setup=true&lang=js"

import "./authInfos.vue?vue&type=style&index=0&id=c8c03d6c&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8c03d6c"]])

export default __exports__